import React from 'react';
import ApiGroupManagementRouter from './ApiGroupManagementRouter';

export default function ApiGroupManagementPage() {
  return <><ApiGroupManagementRouter /></>;
}
